@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@top-border-height: 5px;

.svg-theme() {
  > svg {
    color: @notification--icon--fill-color;
  }

  &.theme-success {
    > svg {
      color: @notification--icon--theme-success--fill-color;
    }
  }

  &.theme-error {
    > svg {
      color: @notification--icon--theme-error--fill-color;
    }
  }

  &.theme-warning {
    > svg {
      color: @notification--icon--theme-warning--fill-color;
    }
  }
}

.notification {
  padding: 15px;
  border: 1px solid @notification--border-color;
  border-top: @top-border-height solid transparent;
  position: relative;
  width: 500px;
  max-width: calc(100vw - 20px);
  background: @notification--background-color;
  border-radius: 0 0 4px 4px;
  display: flex;

  &.has-image {
    .img-container {
      width: 85px;
      min-width: 85px;
      margin-right: 20px;

      .image {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
      }
    }
  }
}

.progress-bar-positioning-wrapper {
  position: absolute;
  top: -1 * @top-border-height;
  left: -1px;
  right: -1px;
  height: @top-border-height;
}

.close-button {
  .svg-theme();
  position: absolute;
  top: 10px;
  right: 10px;
  height: 20px;
  width: 20px;
  cursor: pointer;

  > svg {
    position: relative;
    top: -10px;
    left: -10px;
    display: block;
    width: 40px;
    height: 40px;
    transform: scale(0.26);
  }

  &.mobile {
    position: unset;
    > svg {
      color: @notification--mobile--text-color;
    }
  }

  &:hover {
    opacity: 0.5;
  }
}

.notification-content {
  display: flex;
  width: 100%;
}

.notification-icon-wrapper {
  .svg-theme();
  display: flex;
  margin-right: 10px;
  margin-top: 3px;
  width: 18px;

  > svg {
    height: 18px;
  }
}

.notification-title {
  font-weight: @bold;
  font-size: 16px;
  padding-right: 10px;
  margin-bottom: 10px;
  color: @notification--title--text-color;

  &.theme-error {
    color: @notification--title--theme-error--text-color;
  }

  &.theme-success {
    color: @notification--title--theme-success--text-color;
  }

  &.theme-warning {
    color: @notification--title--theme-warning--text-color;
  }
}

.notification-body {
  font-size: 14px;
  line-height: 24px;
  color: @notification--body--text-color;
  p {
    margin-bottom: 8px;
  }
}

.buttons {
  display: flex;
  margin-top: 15px;
  button {
    margin-right: 15px;
  }
}
